module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/General/Size-09dce8291a403b7bf697c58f19015c74a4bf979b016e614bf91674da3e93d80b.svg";